import React from "react";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import CoreIcon from "../CoreIcon";

const Facebook = props => {
    const {dependency_root} = ClientConfigurationHelper.getGlobalConfiguration();
    const imgSrc = dependency_root+"static/images/socials/facebook.png";
    return <CoreIcon imgSrc={imgSrc} {...props}/>
}

export default Facebook;